import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { useForm } from "react-hook-form";
import SelectWithFilter from "../../../../../components/SelectWithFilter/SelectWithFilter";

export const Embarques = ({
  remover,
  setCatalogs,
  catalogs,
  index,
  currentOptios,
  handleFormData,
  showDG,
}) => {
  const [statusCof, setStatusCof] = useState(false);
  const statusCollapseCofepris = () => setStatusCof((prev) => !prev);

  index += 1;

  const formatSelet = (obj) => {
    const options = [];
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        options.push({
          value: key,
          label: obj[key],
        });
      }
    }
    return options;
  };

  const getCatalogMerchandiseCode = async (inputValue) => {
    try {
      if (inputValue.length >= 4) {
        const response = await axios.get(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/catalogs_cartaporte/getClaveProdServCP/${inputValue}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        setCatalogs((prevOptions) => ({
          ...prevOptions,
          merchandiseKey: response.data.data,
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleInputChange = (inputValue) => {
    getCatalogMerchandiseCode(inputValue);
  };

  //vista final
  return (
    <div className="clons-container">
      <div className="clonable row">
        <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
          <label className="mb-2">Clave de mercancia</label>
          <SelectWithFilter
            options={formatSelet(catalogs.merchandiseKey)}
            current={currentOptios.merchandiseKey[index]}
            onInputChange={handleInputChange}
            id="bienesTranspField"
            name={"bienesTranspField"}
            handleFormData={handleFormData}
            index={index}
            showDG={showDG}
          />
        </div>
        <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
          <label className="mb-2">Clave Unidad</label>
          <SelectWithFilter
            options={formatSelet(catalogs.unidad)}
            current={currentOptios.unidad[index]}
            id={"claveUnidadField"}
            name={"claveUnidadField"}
            handleFormData={handleFormData}
            index={index}
          />
        </div>
        <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
          <label className="mb-2">Cantidad</label>
          <input
            type="text"
            className="form-control"
            id="cantidadField"
            min="1"
            defaultValue={currentOptios.amounts[index] || ""}
            name="cantidadField"
            onChange={(e) => {
              handleFormData(e, index);
            }}
          />
        </div>
        <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
          <label className="mb-2">Peso</label>
          <input
            type="text"
            className="form-control"
            id="pesoEnKgField"
            min="1"
            defaultValue={currentOptios.weights[index] || ""}
            name="pesoEnKgField"
            onChange={(e) => {
              handleFormData(e, index);
            }}
          />
        </div>
        <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
          <label className="mb-2">Valor</label>
          <input
            type="text"
            className="form-control"
            id="valorMercanciaField"
            min="1"
            defaultValue={currentOptios.worths[index] || ""}
            name="valorMercanciaField"
            onChange={(e) => {
              handleFormData(e, index);
            }}
          />
        </div>
        <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
          <label className="mb-2">Moneda</label>
          <SelectWithFilter
            options={formatSelet(catalogs.currency)}
            current={currentOptios.currency[index]}
            id={"monedaField"}
            name={"monedaField"}
            handleFormData={handleFormData}
            index={index}
          />
        </div>
        <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
          <label className="mb-2">Descripción de la mercancia</label>
          <input
            type="text"
            className="form-control"
            id="descripcionField"
            placeholder=""
            defaultValue={currentOptios.descriptions[index] || ""}
            name="descripcionField"
            onChange={(e) => {
              handleFormData(e, index);
            }}
          />
        </div>
        <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
          <label className="mb-2">Eliminar</label>
          <br />
          <button
            type="button"
            className="btn btn-danger"
            style={{
              padding: "5px 10px",
              minWidth: "40px",
              minHeight: "30px",
              cursor: "pointer",
            }}
            onClick={() => remover(index)}
          >
            <svg
              className="svg-inline--fa fa-times fa-w-11"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="times"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 352 512"
              data-fa-i2svg=""
              style={{ color: "white" }}
            >
              <path
                fill="currentColor"
                d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
              ></path>
            </svg>
          </button>
        </div>
        <div className="container my-2">
          <button
            type="button"
            className="btn btn-primary custom-background collapsed"
            onClick={statusCollapseCofepris}
          >
            COFEPRIS
            <svg
              className={
                "bi bi-chevron-down " + (statusCof ? "icon-down" : "icon-up")
              }
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginLeft: "5px" }}
            >
              <path
                fillRule="evenodd"
                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.793l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
              />
            </svg>
          </button>
          <div
            className={
              "row mt-4 " +
              (statusCof ? "active-collapse" : "collapse-cofepris")
            }
          >
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">Sector COFEPRIS</label>
              <SelectWithFilter
                options={formatSelet(catalogs.cofepris)}
                current={currentOptios.cofepris[index]}
                id={"sectorCOFEPRIS"}
                name={"sectorCOFEPRIS"}
                handleFormData={handleFormData}
                index={index}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">Nombre Ingrediente Activo</label>
              <input
                type="text"
                className="form-control"
                id="nombreIngredienteActivo"
                placeholder=""
                defaultValue={currentOptios.activeIngredientName[index] || ""}
                name="nombreIngredienteActivo"
                onChange={(e) => {
                  handleFormData(e, index);
                }}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">Nombre Químico</label>
              <input
                type="text"
                className="form-control"
                id="nomQuimico"
                placeholder=""
                defaultValue={currentOptios.cemicalNames[index] || ""}
                name="nomQuimico"
                onChange={(e) => {
                  handleFormData(e, index);
                }}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">Denominación Genérica del Producto</label>
              <input
                type="text"
                className="form-control"
                id="denominacionGenericaProd"
                placeholder=""
                defaultValue={currentOptios.denominations[index] || ""}
                name="denominacionGenericaProd"
                onChange={(e) => {
                  handleFormData(e, index);
                }}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">
                Denominación Distintiva del Producto
              </label>
              <input
                type="text"
                className="form-control"
                id="denominacionDistintivaProd"
                placeholder=""
                defaultValue={
                  currentOptios.distinctiveDenominations[index] || ""
                }
                name="denominacionDistintivaProd"
                onChange={(e) => {
                  handleFormData(e, index);
                }}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">Fabricante</label>
              <input
                type="text"
                className="form-control"
                id="fabricante"
                placeholder=""
                defaultValue={currentOptios.makers[index] || ""}
                name="fabricante"
                onChange={(e) => {
                  handleFormData(e, index);
                }}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">Fecha de Caducidad</label>
              <input
                type="date"
                className="form-control"
                id="fechaCaducidad"
                placeholder="dd/mm/aaaa"
                defaultValue={currentOptios.dateExpiries[index] || ""}
                name="fechaCaducidad"
                onChange={(e) => {
                  handleFormData(e, index);
                }}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">Lote del Medicamento</label>
              <input
                type="text"
                className="form-control"
                id="loteMedicamento"
                placeholder=""
                defaultValue={currentOptios.medicationBatches[index] || ""}
                name="loteMedicamento"
                onChange={(e) => {
                  handleFormData(e, index);
                }}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">Forma Farmacéutica</label>
              <SelectWithFilter
                options={formatSelet(catalogs.pharmacist)}
                current={currentOptios.pharmacist[index]}
                name={"formaFarmaceutica"}
                id={"formaFarmaceutica"}
                handleFormData={handleFormData}
                index={index}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">
                Condiciones Especiales de Transporte
              </label>
              <SelectWithFilter
                options={formatSelet(catalogs.conditionsSpecial)}
                current={currentOptios.conditionsSpecial[index]}
                id={"condicionesEspTransp"}
                name={"condicionesEspTransp"}
                handleFormData={handleFormData}
                index={index}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">
                Registro Sanitario Folio de Autorización
              </label>
              <input
                type="text"
                className="form-control"
                id="registroSanitarioFolioAutorizacion"
                placeholder=""
                defaultValue={currentOptios.healthRegisters[index] || ""}
                name="registroSanitarioFolioAutorizacion"
                onChange={(e) => {
                  handleFormData(e, index);
                }}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-3 mb-2">
              <label className="mb-2">Permiso de Importación</label>
              <input
                type="text"
                className="form-control"
                id="permisoImportacion"
                placeholder=""
                defaultValue={currentOptios.importPermits[index] || ""}
                name="permisoImportacion"
                onChange={(e) => {
                  handleFormData(e, index);
                }}
              />
            </div>
          </div>
        </div>
        <hr className="mt-2"></hr>
      </div>
    </div>
  );
};
